import { Input as AntInput } from 'antd';
import { DeleteOutlined, FileOutlined, UploadOutlined } from '@ant-design/icons';

import { Button, Card, Form, Input, Text } from '@bancobarigui/barihaus';

type Props = {
  selectedFile: File | null;
  handleRemoveFile: () => void;
  formatFileSize: (bytes: number) => string;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export function AttachmentForm({
  selectedFile,
  formatFileSize,
  handleFileChange,
  handleRemoveFile,
}: Props) {
  return (
    <>
      <div className="space-y-4">
        <Text>Arquivo</Text>

        {!selectedFile ? (
          <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg p-8 text-center hover:border-primary transition-colors">
            <input
              type="file"
              id="file-upload"
              className="!hidden"
              onChange={handleFileChange}
              accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.zip,.rar"
            />
            <label
              htmlFor="file-upload"
              className="cursor-pointer flex flex-col items-center gap-3"
            >
              <UploadOutlined className="text-4xl text-gray-400" />
              <div>
                <Text className="block text-primary font-medium">
                  Clique para selecionar um arquivo
                </Text>
                <Text className="block text-xs text-gray-500 mt-1">
                  PDF, DOC, XLS, JPG, PNG, ZIP (máx. 10MB)
                </Text>
              </div>
            </label>
          </div>
        ) : (
          <Card className="!p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <FileOutlined className="text-2xl text-primary" />
                <div>
                  <Text className="block font-medium">{selectedFile.name}</Text>
                  <Text className="block text-xs text-gray-500">
                    {formatFileSize(selectedFile.size)} • {selectedFile.type || 'Arquivo'}
                  </Text>
                </div>
              </div>
              <Button type="text" danger icon={<DeleteOutlined />} onClick={handleRemoveFile}>
                Remover
              </Button>
            </div>
          </Card>
        )}

        <Form.Item
          name="file"
          rules={[{ required: true, message: 'Selecione um arquivo' }]}
          style={{ display: 'none' }}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="description"
          label="Descrição"
          rules={[{ required: true, message: 'Informe uma descrição para o anexo.' }]}
        >
          <AntInput.TextArea
            rows={3}
            placeholder="Ex: Documento de identidade, Comprovante de endereço, etc."
          />
        </Form.Item>
      </div>
    </>
  );
}
